<template>
  <Loader v-if="loading"/>
  <div v-else>
    <h2 class="text-indigo-700 mb-2 font-bold">{{ $lang.app.RESOLUTIONS }}</h2>
    <template v-for="resolution in resolutions" :key="resolution.id">
      <div class="block rounded border mb-4 py-2 px-3">
        <div class="flex justify-between items center mb-2">
          <h4 class="text-blue-500 font-medium">
            <router-link :to="{ name: 'EmployeeApplicationsResolutionsDetail', params: { resolutionId: resolution.id }}">
              {{ resolution.title }}
            </router-link>
          </h4>
          <h5 class="text-white bg-green-500 rounded-full text-sm px-4 py-0.5">{{ resolution.statusText }}</h5>
        </div>
        <div v-if="getResolutionTypeValueByKey('AGREEMENT') === resolution.type">
          <p class="font-medium mb-1">
            <span class="font-normal text-gray-500">{{ $lang.app.RESPONSIBLE }}: </span>
            {{ responsibleFullName(resolution) }}
          </p>
          <p class="block text-sm text-gray-500 leading-tight mb-2">
            {{ responsiblePosition(resolution) }}
          </p>
        </div>
        <div v-if="getResolutionTypeValueByKey('MAIN') === resolution.type">
          <p class="font-medium mb-1">
            <span class="font-normal text-gray-500">{{ $lang.app.CURATOR }}: </span>
            {{ curatorFullName(resolution) }}
          </p>
          <p class="block text-sm text-gray-500 leading-tight mb-2">
            {{ curatorPosition(resolution) }}
          </p>
        </div>
        <ResolutionListAnswer v-if="resolutionStatusesGetValueByKey('FINISH') == resolution.status"
                               :resolution="resolution"/>
      </div>
      <div class="pl-16">
        <div v-for="childResolution in resolution.children" :key="childResolution.id"
             class="block rounded border mb-4 py-2 px-3">
          <div class="flex justify-between items center mb-2">
            <h4>
              <router-link :to="{ name: 'EmployeeApplicationsResolutionsDetail', params: { resolutionId: childResolution.id }}">
                <span class="text-blue-500 font-medium">{{ childResolution.title }}</span>
                <span v-if="hasDocNumber(childResolution)" 
                      class="ml-2 text-gray-500 text-sm"
                      :title="$lang.app.NUMBER">({{ getDocNumber(childResolution) }})</span>
              </router-link>
            </h4>
            <h5 class="text-white bg-green-500 rounded-full text-sm px-4 py-0.5">{{ childResolution.statusText }}</h5>
          </div>
          <div class="flex justify-between items-start">
            <div>
              <p class="font-medium mb-1">
                <span class="font-normal text-gray-500">{{ $lang.app.RESPONSIBLE }}: </span>
                {{ responsibleFullName(childResolution) }}
              </p>
              <p class="block text-sm text-gray-500 leading-tight mb-2">
                {{ responsiblePosition(childResolution) }}
              </p>
            </div>
            <div v-if="resolutionStatusesGetValueByKey('FINISH') == childResolution.status"
                 class="flex items-center">
              <div class="w-4 h-4 rounded-full mr-2"
                   :class="{
                'bg-green-500': childResolution.lastAnswer.type === answerTypesGetValueByKey('POSITIVE'),
                'bg-orange-400': childResolution.lastAnswer.type === answerTypesGetValueByKey('REMARK'),
                'bg-red-500': childResolution.lastAnswer.type === answerTypesGetValueByKey('NEGATIVE'),
              }"></div>
              <p class="text-sm mr-2"
                 :class="{
                'text-green-500': childResolution.lastAnswer.type === answerTypesGetValueByKey('POSITIVE'),
                'text-orange-400': childResolution.lastAnswer.type === answerTypesGetValueByKey('REMARK'),
                'text-red-500': childResolution.lastAnswer.type === answerTypesGetValueByKey('NEGATIVE'),
              }">
                {{ $lang.app[answerTypesGetLabelRefByValue(childResolution.lastAnswer.type)] }}
              </p>
            </div>
          </div>
          <ResolutionListAnswer v-if="resolutionStatusesGetValueByKey('FINISH') == childResolution.status"
                                 :resolution="childResolution"/>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import resolutionApi from "../../../../../api/employee/resolution";
import { getValueByKey as getResolutionTypeValueByKey} from "../../../../../helpers/constants/resolutionTypes";
import ResolutionListAnswer from "../../../../../components/employee/application/resolution/ResolutionListAnswer";
import {getValueByKey as resolutionStatusesGetValueByKey} from "../../../../../helpers/constants/resolutionStatuses";
import {
  getLabelRefByValue as answerTypesGetLabelRefByValue,
  getValueByKey as answerTypesGetValueByKey,
} from "../../../../../helpers/constants/answerTypes";

export default {
  components: {
    ResolutionListAnswer
  },
  data() {
    return {
      loading: false,
      resolutions: []
    }
  },
  created() {
    this.fetchResolutions()
  },
  watch: {
    '$route'(value) {
      if(value.name === 'EmployeeApplicationResolutions') {
        this.fetchResolutions()
      }
    }
  },
  methods: {
    getResolutionTypeValueByKey,
    resolutionStatusesGetValueByKey,
    answerTypesGetLabelRefByValue,
    answerTypesGetValueByKey,
    fetchResolutions() {
      this.loading = true
      resolutionApi.getApplicationResolutions(this.$route.params.applicationId)
          .then(res => {
            this.resolutions = res
          }).finally(() => {
            this.loading = false
          })
    },
    hasDocNumber(resolution) {
      return resolution.additionalAgreement?.number
    },
    getDocNumber(resolution) {
      return resolution.additionalAgreement?.agreement?.number + '/' + resolution.additionalAgreement.number
    },
    responsiblePosition(resolution) {
      let responsible = resolution.executors.find(e => e.responsible)
      return this.executorPosition(responsible)
    },
    responsibleFullName(resolution) {
      return resolution.executors.find(e => e.responsible)?.employment.fullName
    },
    curatorPosition(resolution) {
      let responsible = resolution.executors.find(e => e.curator)
      return this.executorPosition(responsible)
    },
    curatorFullName(resolution) {
      return resolution.executors.find(e => e.curator)?.employment.fullName
    },
    executorPosition(executor) {
      if(executor) {
        return this.$lang.$translate({
              ru: executor.employment.position.nameRu,
              kg: executor.employment.position.nameKg
            }) + ' | ' +
            this.$lang.$translate({
              ru: executor.employment.position.department.nameRu,
              kg: executor.employment.position.department.nameKg
            })
      }
      return '-'
    }
  }
}
</script>
